<div class="card">
  <div
    class="relative overflow-hidden h-12rem bg-primary text-primary-contrast flex flex-column align-items-center justify-content-center border-round-md mb-8"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      class="absolute w-full top-0 left-0"
    >
      <path
        fill="var(--primary-200)"
        fill-opacity="1"
        d="M0,64L48,90.7C96,117,192,171,288,208C384,245,480,267,576,256C672,245,768,203,864,165.3C960,128,1056,96,1152,74.7C1248,53,1344,43,1392,37.3L1440,32L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
      ></path>
    </svg>
    <div class="font-bold mb-5 text-4xl z-5">
      {{ 'main_layout.welcome' | translate }}
    </div>
  </div>
  <div #menuGridContainer class="grid mb-5 relative">
    <!-- Capa transparente que bloquea el menú cuando está deshabilitado -->
    <div 
      *ngIf="!menuEnabled()" 
      class="menu-grid-disabled-overlay"
    ></div>
    @for (item of itemsOptions(); track $index) { @if(item.visible){
    <div class="col-12 md:col-4 lg:col-3 mb-5">
      <div class="flex flex-column align-items-center">
        <span
          class="inline-flex align-items-center justify-content-center border-circle w-5rem h-5rem bg-primary-100 mb-5"
        >
          <i class="text-4xl text-primary-700" [ngClass]="item.icon"></i>
        </span>
        <div class="text-2xl mb-4 font-medium">
          {{ item.label || '' | translate | titlecase }}
        </div>
        <ul class="list-none m-0 p-0 text-center">
          <li class="leading-normal mb-1">
            <p
              class="text-surface-500 dark:text-surface-400 hover:text-primary cursor-pointer"
            >
              {{ item.tooltip || '' | translate }}
            </p>
          </li>
          <li>
            <a
              class="text-primary hover:underline cursor-pointer font-medium"
              [routerLink]="item.routerLink"
              >{{ 'main_layout.view_all' | translate }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    } }
  </div>
</div>
